import React from "react";
import Slider from "react-slick";
import {PAYLOAD} from "../Body/payloads";

export default function Carousel(p) {
    let settings = {
        swipe: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: p.config.mediumResizeWidth,
        slidesToScroll: 1,
    };

    return (
        <React.Fragment>
            <div className="s">{PAYLOAD(p.payload.header)}</div>
            {p.isShow && <React.Fragment>
                <div className="sm-carousel">
                    <Slider {...settings}>
                        {p.payload.cards.map((card, i) => {
                                let payload = card.button.payload;

                                if (card.payload) {
                                    return <div className="carousel__item" key={i}>
                                        <img src={card.payload.url} alt={card.payload.altText ? card.payload.altText : 'img'}/>
                                        <button className="content-button"
                                                key={payload.text}
                                                onClick={() => p.fn(payload)}
                                        >{PAYLOAD(payload)}</button>
                                    </div>
                                } else {
                                    return <div className="carousel__item" key={i}>
                                        <button className="content-button"
                                                key={payload.text}
                                                onClick={() => p.fn(payload)}
                                        >{PAYLOAD(payload)}</button>
                                    </div>
                                }
                            }
                        )}
                    </Slider>
                </div>
            </React.Fragment>}
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js